import * as React from "react";
import {Link} from "react-router";

export default function Homepage() {
    return <div style={{maxWidth: "500px"}}>
        <h1 className="text-center display-1 mb-2 mb-md-4">
            <Link className="text-dark" to={"/"}>Daily Puzzles</Link>
        </h1>

        <div className="list-group">
            <Link to={"/lexicorder"} className="list-group-item list-group-item-action">
                <h5>
                    Lexicorder
                </h5>
                <small>
                    Guess the word based on it's alphabetical position in the list.
                </small>
            </Link>
            <Link to={"/numericorder"} className="list-group-item list-group-item-action">
                <h5>
                    Numericorder
                </h5>
                <small>
                    Guess the word based on it's numeric ranking in the list.
                </small>
            </Link>
            <div className="list-group-item">
                More coming soon...
            </div>
        </div>
    </div>
}
